module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md6": "",
      "offset-md3": "",
      "offset-sm1": ""
    }
  }, [(!_vm.hascotizacion) ? _c('cliente-cotizacion') : (_vm.hascotizacion) ? _c('v-card', {
    staticClass: "factura",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 80) { return null; }
        if (!$event.ctrlKey) { return null; }
        return _vm.impresion($event)
      }
    }
  }, [_c('v-card-title', {
    staticClass: "primary"
  }, [_c('div', {
    staticClass: "encabezado",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "margin": "0",
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "name": "cliente"
    }
  }, [_vm._v(" Cliente: " + _vm._s(_vm.cliente.cliente))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "factura__date"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._v(" Fecha: " + _vm._s(_vm.fecha))])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 ma-0 total",
    attrs: {
      "xs6": ""
    }
  }, [_c('h5', {
    staticClass: "white--text"
  }, [_vm._v("Total: Q." + _vm._s(_vm.total))])]), _vm._v(" "), _c('h4', {
    staticClass: "warning--text existencia"
  }, [_vm._v(" Existencia: " + _vm._s(_vm.producto.existencia))]), _vm._v(" "), _c('v-flex', [(_vm.haslineas) ? _c('v-btn', {
    staticClass: "print",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("print")])], 1) : _vm._e(), _vm._v(" "), (_vm.haslineas) ? _c('v-btn', {
    staticClass: "print yellow darken-4",
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.guardarcotizacion
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("save")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "print",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "primary": "",
      "disabled": _vm.validatefactura
    },
    on: {
      "click": function($event) {
        return _vm.focusbusqueda()
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogbusqueda = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("search")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "accent": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.message = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("email")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [(_vm.error) ? _c('v-alert', {
    attrs: {
      "error": "",
      "value": "false"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.message_error) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "buscador ma-0 pa-0",
    attrs: {
      "fluid": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    ref: "search",
    attrs: {
      "id": "search",
      "singleLine": "",
      "label": "cod.Producto",
      "disabled": _vm.validatefactura,
      "autofocus": "true"
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 80) { return null; }
        if (!$event.ctrlKey) { return null; }
        return _vm.impresion($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchproducto($event)
      }]
    },
    model: {
      value: (_vm.producto.barra),
      callback: function($$v) {
        _vm.$set(_vm.producto, "barra", $$v)
      },
      expression: "producto.barra"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "singleLine": "",
      "label": "precio",
      "autofocus": "",
      "disabled": ""
    },
    model: {
      value: (_vm.precio),
      callback: function($$v) {
        _vm.precio = $$v
      },
      expression: "precio"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "singleLine": "",
      "label": "producto",
      "disabled": ""
    },
    model: {
      value: (_vm.producto.producto),
      callback: function($$v) {
        _vm.$set(_vm.producto, "producto", $$v)
      },
      expression: "producto.producto"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm1": ""
    }
  }, [_c('v-text-field', {
    ref: "cantidad",
    attrs: {
      "type": "number",
      "singleLine": "",
      "label": "cantidad"
    },
    on: {
      "change": function($event) {
        return _vm.checklista()
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.guardarventa($event)
      }
    },
    model: {
      value: (_vm.cantidad),
      callback: function($$v) {
        _vm.cantidad = $$v
      },
      expression: "cantidad"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.presentacion),
      expression: "presentacion"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.presentacion = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.checklista]
    }
  }, _vm._l((_vm.presentaciones), function(press) {
    return _c('option', {
      domProps: {
        "value": press
      }
    }, [_vm._v("\n                " + _vm._s(press.presentacion) + "\n              ")])
  }), 0)])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "select xs6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.listado),
      expression: "listado"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.listado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.checklista]
    }
  }, _vm._l((_vm.producto.listaprecios), function(lista) {
    return _c('option', {
      domProps: {
        "value": lista
      }
    }, [_vm._v("\n                " + _vm._s(lista.lista.nombre) + "\n              ")])
  }), 0)])]), _vm._v(" "), _c('v-flex', {
    staticClass: "justify-center",
    attrs: {
      "hidden-md-and-up": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "print blue darken-4",
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.guardarventa
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("save")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hascotizacion),
      expression: "hascotizacion"
    }],
    staticClass: "factura__detalle"
  }, [_c('v-flex', {
    staticClass: "tabla",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table text-md-center"
  }, [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.headers), function(header) {
    return _c('th', [_vm._v(" " + _vm._s(header.text))])
  })], 2), _vm._v(" "), _c('tbody', [_vm._l((_vm.lineas), function(linea) {
    return _c('tr', [_c('td', [_c('v-btn', {
      staticClass: "red--text text--darken-2",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.eliminar(linea)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(linea.cantidad))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(linea.presentacion))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(linea.producto_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(linea.precio))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(linea.precio * linea.cantidad, 'Q')))])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "factura__detalle__total"
  }, [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.total))])])], 2)])])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Imprimir Cotización")])]), _vm._v(" "), _c('v-card-text', [(_vm.error) ? _c('v-alert', {
    attrs: {
      "error": "",
      "value": "false"
    }
  }, [_vm._v("\n         " + _vm._s(_vm.message_error) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.imprimircotizacion($event)
      }
    }
  }, [_vm._v("Aceptar")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialogbusqueda),
      callback: function($$v) {
        _vm.dialogbusqueda = $$v
      },
      expression: "dialogbusqueda"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Buscar Producto")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [_c('v-text-field', {
    ref: "searchprodi",
    attrs: {
      "label": "Nombre",
      "autofocus": ""
    },
    on: {
      "keyup": _vm.searchproductos
    },
    model: {
      value: (_vm.nombreproducto),
      callback: function($$v) {
        _vm.nombreproducto = $$v
      },
      expression: "nombreproducto"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('ul', {
    staticClass: "listadoproducto"
  }, _vm._l((this.productos), function(product, key) {
    return _c('li', {
      attrs: {
        "tabindex": 0
      },
      on: {
        "click": function($event) {
          _vm.searchproductodialog(product), _vm.dialogbusqueda = false, _vm.nombreproducto = ''
        },
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          _vm.searchproductodialog(product), _vm.dialogbusqueda = false, _vm.nombreproducto = ''
        }
      }
    }, [_vm._v("\n             " + _vm._s(product.producto) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "tabindex": -1,
      "flat": "flat"
    },
    on: {
      "click": _vm.resetbusqueda
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogbusqueda = false
      }
    }
  }, [_vm._v("Cancelar")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "enletras",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', [_vm._v("TOTAL EN LETRAS: " + _vm._s(_vm.numerosaletras))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "firmas"
  }, [_c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_vm._v("Cliente")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-105a8862"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cotizacionadd.vue
// module id = 427
// module chunks = 1